import React from 'react'

import { TabelaColuna } from 'src/componentes'

export const colunaCodigoCurso = (): TabelaColuna => ({
  Chave: 'codigoCursoTurma',
  ComOrdenacao: true,
  RenderizarCabecalho: () => <div style={{ width: 200 }}>Codigo Curso</div>
})
